import _ from 'lodash';

class ExpandButtons {
  constructor() {
    this.gridExpandButton = {};
    this.workloadExpandButton = {
      height: 20,
    };

    this.debouncedUpdatePositions = _.debounce(() => {
      this._resizeGridExpandButton();
      this._resizeWorkloadExpandButton();
    }, 10);
  }

  init(instance) {
    this.ganttInstance = instance;
    this._createGridExpandButton();

    if (!this.ganttInstance.config.isArchived) this._createWorkloadExpandButton();
  }

  _createGridExpandButton() {
    const el = document.getElementsByClassName('gantt_layout_root')[0];

    if (this.gridExpandButton.node) {
      return el?.parentNode.insertBefore(this.gridExpandButton.node, el.nextSibling);
    }

    this.gridExpandButton.node = document.createElement('div');
    this.gridExpandButton.node.className = `gantt_expand_button gantt_${this.ganttInstance.skin}`;

    this.gridExpandButton.node.innerHTML = `<div class="gantt_expand_button_bottom"></div><div class="gantt_expand_button_text">${__('gantt_grid_expand_button_text')}</div>`;
    this.gridExpandButton.node.addEventListener('click', () => {
      this.ganttInstance.config.show_grid = !this.ganttInstance.config.show_grid;
      if (this.ganttInstance.ganttDataApi.isHistory()) {
        this.ganttInstance.render();
      } else {
        this.ganttInstance.callEvent('setShowGrid', [this.ganttInstance.config.show_grid]);
        this.ganttInstance.callEvent('onClickGridExpandButton', []);
      }
    });

    el?.parentNode.insertBefore(this.gridExpandButton.node, el.nextSibling);
  }

  _createWorkloadExpandButton() {
    const el = document.getElementsByClassName('workload-body')[0];

    if (this.workloadExpandButton.node) {
      return el?.parentNode.insertBefore(this.workloadExpandButton.node, el.nextSibling);
    }

    this.workloadExpandButton.node = document.createElement('div');
    this.workloadExpandButton.node.className = `gantt_workload_expand_button gantt_${this.ganttInstance.skin}`;
    this.workloadExpandButton.node.style.height = `${this.workloadExpandButton.height}px`;
    this.workloadExpandButton.node.addEventListener('click', () => {
      this.ganttInstance.callEvent('onClickWorkloadExpandButton', []);
    });

    el?.parentNode.insertBefore(this.workloadExpandButton.node, el.nextSibling);
  }

  _resizeGridExpandButton() {
    if (!this.gridExpandButton.node) {
      return;
    }

    const box = document.getElementsByClassName('timeline_cell')[0];

    if (!box) {
      this.gridExpandButton.node.style.display = 'none';

      return;
    }

    this.gridExpandButton.node.style.display = 'block';
    this.gridExpandButton.node.firstChild.className = this._getGridButtonClass();
    this.gridExpandButton.node.style.left = `${
      this.ganttInstance.config.show_grid
        ? this.ganttInstance.config.grid_width - 3
        : 10 - this.gridExpandButton.node.offsetWidth / 2
    }px`;
    this.gridExpandButton.node.style.top = `${(box.clientHeight) / 2}px`;
  }

  _resizeWorkloadExpandButton() {
    if (!this.workloadExpandButton.node) {
      return;
    }

    const parentNodeSize = this.ganttInstance.$task?.getBoundingClientRectWrapper();
    const box = document.getElementsByClassName('timeline_cell')[0];

    if (!box) {
      this.workloadExpandButton.node.style.display = 'none';

      return;
    }

    this.workloadExpandButton.node.style.display = 'flex';
    this.workloadExpandButton.node.innerHTML = `
      <div class="${this._getWorkloadButtonClass()}"></div>
      <div class="gantt_workload_expand_button_text">${this._getWorkloadButtonText()}</div>`;

    this.workloadExpandButton.node.style.right = `${(box.clientWidth - this.workloadExpandButton.node.offsetWidth) / 2}px`;
    this.workloadExpandButton.node.style.top = `${parentNodeSize ? parentNodeSize.height - 2 : 0}px`;
    this.workloadExpandButton.node.style.height = `${this.workloadExpandButton.height}px`;
  }

  _getGridButtonClass() {
    return this.ganttInstance.config.show_grid ? 'gantt_expand_button_right' : 'gantt_expand_button_left';
  }

  _getWorkloadButtonClass() {
    return this.ganttInstance.config.hide_workload ? 'gantt_workload_expand_button_bottom' : 'gantt_workload_expand_button_top';
  }

  _getWorkloadButtonText() {
    return this.ganttInstance.config.hide_workload ? __('gantt_workload_expand_button_text') : '';
  }

  hideWorkloadButton() {
    this.workloadExpandButton.node?.remove();
    delete this.workloadExpandButton.node;
  }
}

export default new ExpandButtons();
